import { render, staticRenderFns } from "./allocated-case.vue?vue&type=template&id=1381d3fa"
import script from "./allocated-case.vue?vue&type=script&lang=ts"
export * from "./allocated-case.vue?vue&type=script&lang=ts"
import style0 from "./allocated-case.vue?vue&type=style&index=0&id=1381d3fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports